import { message, Modal, Popconfirm } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../assets/css/services/sidebar.css";
import HButton from "../../../components/custom/input/button/Button";
import {
  COMPANY_NAME,
  VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY,
  VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY,
} from "../../../constants/AppConstants";
import { AppContext } from "../../../context/AppContext";
import { useRolesContext } from "../../../context/RolesContext";
import useHttp from "../../../hooks/useHttp";
import useLicense from "../../../hooks/useLicense";
import { useVoiceContext } from "../../../voice/context/VoiceContext";
import { getCurrentFeature } from "../../../voice/utils/VoiceUtils";
import { checkIsAdmin } from "../commonUtils";

const UpgradeAlertPopup = (props) => {
    const isMobileApp = navigator.userAgent.includes("HelloSendMobile");
    const { fetchData } = useHttp();
    const [appProperties, setAppProperties] = useContext(AppContext);
    const [rolesProperties] = useRolesContext();
    const [callProperties, setCallProperties] = useVoiceContext();
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    let { upgradeAlertPopup, setUpgradeAlertPopup } = props;
    const [currentPlan, setCurrentPlan] = useState("");
    const { fetchStripeURL } = useLicense();
  
    useEffect(() => {
      const planName = getCurrentFeature(appProperties);
      if (planName) {
        setCurrentPlan(planName);
      }
    }, [appProperties]);
  
    if (!upgradeAlertPopup) return null;
    const path = location.pathname;
    // let currentUserHasUserRolePermission = isCurrentUserHasUserRolePermission(rolesProperties);
    let currentUserHasUserRolePermission = !checkIsAdmin(appProperties, rolesProperties);
  
    const handleRequestAccess = () => {
      setLoading(true);
      const switchToPlan = appProperties?.licenseObj?.licenseDetails?.planName.includes("Monthly")
        ? VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY
        : VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY;
      if (switchToPlan) {
        fetchData(
          `license/switch/plan?switchToPlan=${switchToPlan}&enablePlanInTrialMode=true`,
          "POST",
          null,
          appProperties
        ).then((res) => {
          const response = JSON.parse(res);
          const responseData = response?.data;
          if (responseData) {
            setAppProperties((prev) => ({
              ...prev,
              licenseObj: {
                ...prev.licenseObj,
                licenseDetails: responseData?.license,
              },
            }));
  
            setLoading(false);
            if (path.includes("voice/dialpad") || path.includes("/sendsms")) {
              message.success(
                `Messaging and calling are now enabled for you. Start connecting with your customers effortlessly.`
              );
              setUpgradeAlertPopup(false);
            } else {
              setLoading(false);
              navigate("/settings/number/twilio_voice" + location.search);
              setUpgradeAlertPopup(false);
              setCallProperties((prev) => ({
                ...prev,
                voicePlanRequestAccess: true,
              }));
            }
          }
        });
      }
    };
  
    const handleManageSubscription = (e) => {
      if (appProperties.licenseHandledBy === "STRIPE") {
        fetchStripeURL(appProperties).then(function (stripeLink) {
          window.open(stripeLink.url, "_blank");
        });
      } else {
        appProperties.controller.pricingLink(appProperties).then(function (resp) {
          try {
            const baseUrl = window.location.origin;
            const url = resp.startsWith("http") ? new URL(resp) : new URL(resp, baseUrl);
            url.searchParams.set("requestedPlan", "message+call");
            window.open(url.toString(), "_blank");
          } catch (error) {
            console.error("Error constructing URL:", error, "Response:", resp);
          }
        });
      }
    };
  
    const modalBody = (
      <div className="d-flex justify-content-between gap-3 flex-column ">
        <div className="d-flex justify-content-center">
          <div className="actionIconsSpriteForSideBar modal-upgrade-icon" />
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <div className="d-flex justify-content-center align-items-center flex-column">
            <h5 className="hs-color-dark-blue">{`Activate ${
              currentPlan === "Message" ? "Call" : currentPlan === "Call" ? "Message" : ""
            } Capability`}</h5>
            <div className="hs-color-dark-blue">
              You're just one step away from unlocking the {COMPANY_NAME}
              {currentPlan === "Message" ? " Call" : currentPlan === "Call" ? " Message" : ""} capability! Simply{" "}
              {currentPlan !== "Call" ? "get access or " : ""}upgrade to a higher plan to get started.
              {currentPlan === "Call" && currentUserHasUserRolePermission ? " Contact your administrator" : ""}
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between gap-2">
          {currentPlan !== "Call" && !currentUserHasUserRolePermission && (
            <div className={`${currentUserHasUserRolePermission ? "w-100" : "w-50"}`}>
              <Popconfirm
                rootClassName="w-25 get-access-popconfirm"
                placement="top"
                title="Get Access"
                description="Upgrade now and enjoy a 5-day free trial of HelloSend Call — no commitment required!"
                okText="Yes"
                onConfirm={handleRequestAccess}
              >
                <HButton type="secondary" loading={loading} buttonClassName="hs-fw-400 w-100" variant="cancel">
                  Get Access
                </HButton>
              </Popconfirm>
            </div>
          )}
          {!currentUserHasUserRolePermission && !appProperties?.controller?.manageSubscriptionBtnHide && !isMobileApp && (
            <div className={`${currentPlan === "Call" && "w-100"}`}>
              <HButton type="primary" buttonClassName="hs-fw-600 w-100" onClick={handleManageSubscription}>
                Manage Subscription
              </HButton>
            </div>
          )}
        </div>
      </div>
    );
    return (
      <>
        <Modal
          className="hs-h-80 d-flex align-items-center"
          width={400}
          mask={true}
          open={upgradeAlertPopup}
          modalCloseIcon={false}
          footer={false}
          closable={!path.includes("voice/dialpad")}
          onCancel={() => setUpgradeAlertPopup(false)}
        >
          {modalBody}
        </Modal>
      </>
    );
};

export default UpgradeAlertPopup;